__turbopack_context__.v({
  "active": "Text-module__gDZTXq__active",
  "textLink": "Text-module__gDZTXq__textLink",
  "underline": "Text-module__gDZTXq__underline",
});
